import { SampleAnchor } from "../PaperShared/Sample";

function Applications() {
  return (
    <section id="Applications">
      <h2>Applications</h2>
      <h3 id="Debugging">Debugging</h3>
      <p>
        Modeling LLMs as black boxes leads to a lack of transparency when trying to address
        hallucinations or errant behavior. Circuit extraction allows us to diagnose issues stemming
        from the existence of undertrained or missing features. As demonstrated via an analysis of
        the circuits associated with <SampleAnchor modelId="baby-v1" sampleId="1089200" />, we gain
        an understanding of what changes within an LLM as we scale its size or improve its training.
      </p>
      <h3 id="DatasetAnalysis">Dataset Analysis</h3>
      <p>
        Circuit analysis offers us a new way of quantifying the effects of training data on the
        output of an LLM. Productive behaviors can be mapped to specific sets of features that, as a
        group, identify relevant samples within a dataset. A list of such samples can be used to
        both validate the effectiveness of certain types of training data and yield recommendations
        for improvements.
      </p>
      <h3 id="SafetyAnalysis">Safety Analysis</h3>
      <p>
        Circuit analysis helps mitigate the risk of harmful behaviors by giving researchers a way of
        auditing key actions within a model. By looking for pathways or processes that lead to
        mistakes, developers can intervene through refining a model’s training data or modifying its
        inputs.
      </p>
    </section>
  );
}

export { Applications };
